export enum WaitingListCommand {
    Leave = 0,
    Join = 1
}
